export default __webpack_public_path__ + "static/media/permission-thrash-icon.60113a66.svg";